import {useQuery} from '@tanstack/react-query'
import {useEffect} from 'react'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  cameraId: number
  onError?: (error: unknown) => void
  enabled?: boolean
}

export default function useScheduleByCamera({cameraId, onError, enabled = true}: Props) {
  const query = useQuery({
    enabled,
    queryKey: [QueryKeyEnum.SCHEDULE_BY_CAMERA, cameraId],
    queryFn: async () => (await api.schedule.getByCamera({cameraId})).data.data,
  })

  useEffect(() => {
    if (query.isError) onError?.(query.error)
  }, [query.error])

  return query
}
